
(function () {
  var figs = [].slice.call(document.querySelectorAll('.pdp-gallery figure img'));
  if (!figs.length) return;
  function big(im) { var s = im.currentSrc || im.src; return /[?&]width=\d+/.test(s) ? s.replace(/([?&])width=\d+/, '$1width=2000') : s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=2000'; }
  var lb = document.createElement('div'); lb.className = 'wa-lb'; lb.hidden = true;
  lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Image viewer');
  lb.innerHTML = '<button type="button" class="wa-lb-x" aria-label="Close">\u00d7</button><button type="button" class="wa-lb-nav is-prev" aria-label="Previous image">\u2039</button><img class="wa-lb-img" alt=""><button type="button" class="wa-lb-nav is-next" aria-label="Next image">\u203a</button><span class="wa-lb-count"></span>';
  document.body.appendChild(lb);
  var img = lb.querySelector('.wa-lb-img'), cnt = lb.querySelector('.wa-lb-count'), cur = 0;
  function show(i) {
    cur = (i + figs.length) % figs.length; var want = cur;
    img.src = figs[cur].currentSrc || figs[cur].src; img.alt = figs[cur].alt || '';
    var hi = new Image(); hi.onload = function () { if (want === cur) img.src = hi.src; }; hi.src = big(figs[cur]);
    cnt.textContent = (cur + 1) + ' / ' + figs.length;
  }
  function open(i) { show(i); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; lb.querySelector('.wa-lb-x').focus(); }
  function close() { lb.hidden = true; document.documentElement.style.overflow = ''; }
  figs.forEach(function (im, i) {
    im.style.cursor = 'zoom-in'; im.setAttribute('tabindex', '0');
    im.addEventListener('click', function () { open(i); });
    im.addEventListener('keydown', function (e) { if (e.key === 'Enter') open(i); });
  });
  lb.querySelector('.wa-lb-x').addEventListener('click', close);
  lb.querySelector('.is-prev').addEventListener('click', function (e) { e.stopPropagation(); show(cur - 1); });
  lb.querySelector('.is-next').addEventListener('click', function (e) { e.stopPropagation(); show(cur + 1); });
  lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
  document.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(cur + 1); else if (e.key === 'ArrowLeft') show(cur - 1); });
  var x0 = null;
  lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (dx > 40 || dx < -40) show(cur + (dx < 0 ? 1 : -1)); x0 = null; });
})();
